// themes/dark.js
// "Vibrant Branded Dark" — deep navy base, very subtle roads, no POIs.
// Marker color is lightened from primaryActionColor for contrast (handled at runtime).
export default [
  { elementType: "geometry", stylers: [{ color: "#0f1420" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#a4adbf" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#0f1420" }] },
  { elementType: "labels.icon", stylers: [{ visibility: "off" }] },

  { featureType: "administrative", elementType: "geometry", stylers: [{ visibility: "off" }] },
  { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
  { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#c0c8da" }] },

  { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#0f1420" }] },
  { featureType: "landscape.natural", elementType: "geometry", stylers: [{ color: "#121828" }] },

  { featureType: "poi", stylers: [{ visibility: "off" }] },
  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#13202a" }] },

  { featureType: "road", elementType: "geometry.fill", stylers: [{ color: "#252b3a" }] },
  { featureType: "road", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] },
  { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
  { featureType: "road.local", stylers: [{ visibility: "off" }] },
  { featureType: "road.arterial", elementType: "labels", stylers: [{ visibility: "off" }] },
  { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "simplified" }] },
  { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#9ca5b3" }] },
  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#2d3447" }] },

  { featureType: "transit", stylers: [{ visibility: "off" }] },

  { featureType: "water", elementType: "geometry", stylers: [{ color: "#0a0e18" }] },
  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#515c6d" }] },
]
